const map = {
	"./__variants__/plp-guided-search/single/SearchPage.js": 2883,
	"./__variants__/plp-guided-search/text/SearchPage.js": 1866,
	"./__variants__/plp-guided-search/tile/SearchPage.js": 167
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7439;